module.exports = __webpack_public_path__ + "static/media/storm.2fb337db.png";